<template>
  <div
    v-clickoutside="close"
    :class="['pickup', { autocomplete__open: popVisible }]"
  >
    <div
      :style="{}"
      :class="['input-container', { pickup__error: !popVisible }]"
    >
      <!-- 前置内容 -->
      <span class="input__prefix">
        <slot name="prefix"> </slot>
      </span>
      <input
        ref="input"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        v-bind="[$props, $attrs]"
        class="by-input__inner"
      />
    </div>
    <transition name="el-zoom-in-top">
      <div v-if="popVisible && !isSearch" class="pickup-suggestion">
        <div class="pickup-tab">
          <div
            :key="tab"
            v-for="(tab, index) in tabOption.tabs"
            @click="clickTab(tab)"
            :class="[tabOption.activeItem === tab ? 'tab-item__active' : '']"
            class="pickup-tab-item"
          >
            <span>{{ tab }}</span>
          </div>
          <TabTrangle
            type="dot"
            :actIndex="tabOption.activeItem"
            activeTabClass=".tab-item__active"
          ></TabTrangle>
        </div>

        <div
          :class="[
            'pickup-content',
            { 'pickup-content__h240': lists.length > 1 },
          ]"
        >
          <div
            :key="index"
            v-for="(content, index) in aPageList"
            @click.stop="clickContent(content)"
            class="pickup-content-item"
          >
            <span>{{ contentName(content) }}</span>
          </div>
        </div>

        <div v-if="lists.length > 1" class="page-container">
          <div class="pickup-page">
            <svg-icon
              @click="pageChange('reduce')"
              size="18"
              name="arrow-left-bold"
              :style="{ opacity: pageIndex === 0 ? '.3' : '' }"
            ></svg-icon>
            <span>{{ pageIndex + 1 }}</span>
            <svg-icon
              :style="{ opacity: pageIndex === lists.length - 1 ? '.3' : '' }"
              @click="pageChange('add')"
              size="18"
              name="arrow-right-bold"
            ></svg-icon>
          </div>
        </div>
      </div>
      <div class="pickup-suggestion" v-if="popVisible && isSearch">
        <div class="searchPanel">
          <div
            class="search-item"
            @click="chooseCity(item)"
            v-for="(item, index) in searchCityList"
            :key="item.City_Code + index"
          >
            <span>{{ item.Province_NameEn }}/{{ item.City_NameEn }}</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  
  <script>
import Emitter from "@/utils/emitter";
import TabTrangle from "@/components/reception/indexPage/TabTrangle.vue";

export default {
  mixins: [Emitter],

  components: {
    TabTrangle,
  },
  inheritAttrs: false,

  props: {
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    provinceAndCity: {
      type: Object,
      default: {
        hotCity: ["深圳", "广州"],
        province: [{ Province_NameEn: "asdas" }],
        allCity: [],
      },
    },
    value: {},
  },
  computed: {
    contentName() {
      return function (content) {
        return content[this.contentMap[this.tabOption.activeItem]];
        //  return 'Province_NameEn'
      };
    },
    provinceCity: {
      cache: false,
      get() {
        return this.provinceAndCity;
      },
    },
    tabMap: {
      cache: false,
      get() {
        return {
          "Favorite city": "hotCity",
          Province: "province",
          Select: "select",
        };
      },
    },
    contentMap: {
      cache: false,
      get() {
        return {
          Select: "City_NameEn",
          "Favorite city": "NameEn",
          Province: "Province_NameEn",
        };
      },
    },
    aPageList: {
      cache: false,
      get() {
        return this.provinceCity[this.tabMap[this.tabOption.activeItem]][
          this.pageIndex
        ];
      },
      set(val) {
        return val;
      },
    },
    lists: {
      cache: false,
      get() {
        return this.provinceCity[this.tabMap[this.tabOption.activeItem]];
      },
      set(val) {
        this.provinceCity.select = val;
      },
    },
  },
  data() {
    return {
      popVisible: false,
      suggestion: [],
      tabOption: {
        tabs: ["Favorite city", "Province"],
        activeItem: "Favorite city",
      },
      pageIndex: 0,
      isSearch: false,
      searchCityList: [],
    };
  },
  mounted() {
    // document.addEventListener('click',(e)=>{
    //   setTimeout(()=>{
    //          if(!this.$el.contains(e.target)&& this.popVisible){
    //     this.dispatch('ByFormItem', 'by.form.blur',[this.value]);
    //   }
    //   },150)
    // })
  },

  methods: {
    pageChange(method) {
      const stratagy = {
        reduce() {
          if (this.pageIndex > 0) {
            this.pageIndex = this.pageIndex - 1;
          }
        },
        add() {
          if (this.pageIndex < this.lists.length - 1) {
            this.pageIndex = this.pageIndex + 1;
          }
        },
      };
      stratagy[method].call(this);
    },
    clickTab(tab) {
      this.tabOption.activeItem = tab;
    },
    clickContent(item) {
      let activeName = this.tabOption.activeItem;
      if (activeName == "Favorite city") {
        this.tabOption.tabs = ["Favorite city", "Province"]; //
        this.tabOption.activeItem = "Favorite city";
        delete this.provinceAndCity["select"];
      }
      // debugger
      const stratagy = {
        "Favorite city": function () {
          console.log(item, 'item');
          this.$emit("input", `${item.Province_NameEn}/${item.NameEn}`);
          this.$emit("select", item);
          this.close();
          // setTimeout(() =>{
          //   this.dispatch("ByFormItem", "by.form.blur", [this.value]);

          // },500)
        },
        Province: function () {
          if (!this.tabOption.tabs.includes("Select")) {
            this.tabOption.tabs.push("Select");
          }
          item.CityList.forEach((selectItem, index) => {
            item.CityList[index].Province_NameEn = item.Province_NameEn;
          });
          this.provinceCity.select = this.dataPaging(item.CityList);
          this.tabOption.activeItem = "Select";
        },
        Select: function () {
          this.$emit("input", `${item.Province_NameEn}/${item.City_NameEn}`);
          this.$emit("select", item);
          this.close();
          // setTimeout(() =>{
          //   this.dispatch("ByFormItem", "by.form.blur", [this.value]);

          // },500)
        },
      };
      stratagy[this.tabOption.activeItem].call(this);
      this.pageIndex = 0;
    },
    //数据分页
    dataPaging(data) {
      let arrs = [[]];
      let page = 0;

      for (let i = 0; i < data.length; i++) {
        if ((i + 1) % 19 === 0) {
          page++;
          arrs[page] = [];
        }
        arrs[page].push(data[i]);
      }
      return arrs;
    },
    focus() {
      this.$refs["input"].focus();
    },
    handleFocus(e) {
      let cl = this.$el.firstChild.innerText;
      let startCity = this.$props.provinceAndCity;
      this.popVisible = true;
      //如果起始地选择了香港或者澳门。目的地只能选择香港和澳门
      if (cl == " *Delivery city ：") {
        if (startCity) {
          if (startCity.select) {
            if (
              startCity.select[0][0].City_Code == "HK" ||
              startCity.select[0][0].City_NameEn == "AoMenTeBieXingZhengQu"
            ) {
              //
              this.tabOption.tabs = ["Select"]; //
              this.tabOption.activeItem = "Select";
            } else {
              this.tabOption.tabs = ["Favorite city", "Province"]; //
              this.tabOption.activeItem = "Favorite city";
            }
          } else {
            this.tabOption.tabs = ["Favorite city", "Province"]; //
            this.tabOption.activeItem = "Favorite city";
          }
        }
      } else {
        this.tabOption.tabs = ["Favorite city", "Province"]; //
        this.tabOption.activeItem = "Favorite city";
      }
    },
    handleBlur(e) {
      // setTimeout(() => {
      //   this.dispatch("ByFormItem", "by.form.blur", [this.value]);
      // }, 150);

      if (this.suggestion.length === 0) {
        this.$emit("input", "");
        return;
      }
    },
    handleInput(e) {
      this.$emit("input", e.target.value);
      let searchText = e.target.value.trim();
      this.isSearch = searchText.length > 0 ? true : false;
      if (this.isSearch) {
        this.searchInput(searchText);
      } else {
        
      }
    },
    // 搜索
    searchInput(searchText) {
      let cityList = this.provinceAndCity.allCity;
      console.log(cityList, "cityList");
      let searchResult = [];
      if (searchText.length > 0) {
        for (let i = 0; i < cityList.length; i++) {
          let item = cityList[i];

          if (item.City_NameEn.length > searchText.length) {
            if (
              item.City_NameEn.toLowerCase().indexOf(searchText.toLowerCase()) !=
              -1
            ) {
              searchResult.push(item);
            }
          } else {
            if (
              searchText.toLowerCase().indexOf(item.City_NameEn.toLowerCase()) !=
              -1
            ) {
              searchResult.push(item);
            }
          }
        }
      }

      this.searchCityList = searchResult;

      console.log(searchResult, "searchResult");
    },
    // 选择城市
    chooseCity(item) {
      console.log(item, 'items');
      this.$emit("input", `${item.Province_NameEn}/${item.City_NameEn}`);
      this.$emit("select", item);
      this.close();
    },
    // handleClick(item) {
    //   //     if(!this.$el.contains(e.target) ){
    //   //     this.dispatch('ByFormItem', 'by.form.blur',[this.value]);
    //   //   }
    //   this.$emit("select", item);
    //   this.$emit("input", item[this.labelKey]);
    //   this.close();
    // },
    //关闭弹框
    close() {
      if (this.popVisible) {
        // dom数据更新为异步
        this.$nextTick(() => {
          this.dispatch("ByFormItem", "by.form.blur", [this.value]);
        });
      }
      this.popVisible = false;
    },
    //筛选数据
  },
};
</script>
  
  <style lang="scss" scoped >
.pickup {
  position: relative;

  height: 60px;
  box-sizing: border-box;
  color: #fff;
  font-size: 15px;
  .input-container {
    font-size: 15px;
    padding: 0 20px;
    position: relative;
    height: 100%;
    background-color: #577ec7;
    border-radius: 30px;
    display: flex;
    overflow: hidden;
    box-sizing: border-box;

    transition: all 0.3s;

    .input__prefix {
      color: #fff;
      // height:100%;
      text-align: center;
      line-height: 60px;
      & > * {
        margin-right: 10px;
      }
    }
  }
  .by-input__inner {
    cursor: pointer;
    height: 100%;
    background-color: #577ec7;
    border: none;
    box-sizing: border-box;
    color: #fff;
    display: inline-block;
    font-size: inherit;
    line-height: 100%;
    outline: none;
    flex: 1;
    &:focus {
      // border-color: red !important;
      outline: none !important;
    }
    @include inputPlaceholder(#abbee3);
  }
  .pickup-suggestion {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: 1;
    background: #577ec7;
    padding: 0 20px 20px;
    box-sizing: border-box;
  }
  .pickup-tab {
    display: flex;
    height: 60px;
    justify-content: space-between;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(#fff, 0.5);
    position: relative;
    .pickup-tab-item {
      text-align: center;
      line-height: 60px;
      width: 113px;
      cursor: pointer;
      &:hover {
        color: #2e5eb9;
      }

      // &.tab-item__active {
      //   position: relative;
      //   &::after {
      //     content: "";
      //     width: 6px;
      //     height: 6px;
      //     background: #ffffff;
      //     border-radius: 50%;
      //     position: absolute;
      //     bottom: 10px;
      //     left: 50%;
      //     transform: translateX(-50%);
      //   }
      // }
    }
  }

  .pickup-content {
    display: flex;
    flex-wrap: wrap;
  }
  .pickup-content.pickup-content__h240 {
    height: 240px;
    align-content: start;
    .pickup-content-item {
      height: 40px;
    }
  }

  .pickup-content-item {
    cursor: pointer;
    width: 113px;
    text-align: center;
    height: 40px;
    line-height: 40px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &:hover {
      background: #89a4d7;
    }
  }

  .page-container {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .pickup-page {
    & > * + * {
      margin-left: 20px;
    }
    .svgicon {
      cursor: pointer;
      &.pickup-page__lastorfirst {
        color: #89a4d7;
      }
    }
  }

  .searchPanel {
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 4px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
      -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
      background: #fff;
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
      // -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
      border-radius: 4px;
      background: transparent;
    }
    .search-item {
      padding: 0 16px;
      border-radius: 4px;
      cursor: pointer;
      text-align: left;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &:hover {
        background: #89a4d7;
      }
    }
  }
}

// // 弹框打开时
.autocomplete__open {
  position: relative;
  .input-container {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 1px solid white;
  }

  // .by-input__inner {
  //   &:focus {
  //     border-radius: 0px !important;
  //     border-color: #fff !important;
  //   }
  // }
}

.is_error .pickup__error.input-container {
  border: 1px solid rgba(red, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/PickUpCity.vue